export const getNavLinkClass = (isActive: boolean) => {
  const baseStyles =
    "text-sm font-semibold text-white flex items-center px-4 py-2 rounded-md transition-all border w-full";

  const activeStyles =
    "bg-opacity-10 bg-[#51E7F9] border-[#51E7F9] border-[1px] text-[#51E7F9]";

  const inactiveStyles = "border-transparent text-white";

  const hoverStyles =
    "hover:border-[#51E7F9] hover:bg-opacity-10 hover:bg-[#51E7F9] hover:border-[1px] hover:text-[#51E7F9]";

  return `${baseStyles} ${
    isActive ? activeStyles : inactiveStyles
  } ${hoverStyles}`;
};